






































import Vue from 'vue';
import { format, parseISO } from 'date-fns';

export default Vue.extend({
  props: {
    externalAttachmentList: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    let externalAttachments = null;
    if (this.externalAttachmentList) {
      externalAttachments = this.externalAttachmentList.slice().reverse();
    }
    return {
      externalAttachments: externalAttachments,
      downloadUrl: '/api/v2/external_attachments/',
    };
  },
  methods: {
    tableRowClass(idx: number) {
      return idx % 2 === 0 ? 'even' : 'odd';
    },
    createdDisplay(created: string) {
      return format(parseISO(created), `MM/dd/yyyy 'at' h:mm a`);
    },
  },
});
